import React from 'react'
import { useContext, useEffect,useState } from 'react';
import DataContext from '../context/DataContext';
import Login from '../Login';
import Logout from '../Logout';
import Layout from '../layout/Layout';
import axiosAUTHAPI from '../api/axiosAUTHAPI';
import Splash from '../pages/Splash';
import { inactivityService } from '../services/InactivityService';
import { getNotifications } from '../api/axiosNotifications';







const Auth = () => {

  const { isUserAuntheticated, setIsUserAuntheticated, setAuntheticatedUser, setNotifications, setIsLoadingNotifications, setFetcherrorNotifications } = useContext(DataContext);
  const [loading, setLoading] = useState(true);
 

  
  useEffect(() => {
    
    inactivityService(setIsUserAuntheticated);

    if (performance.navigation.type === 1) {
            verifyToken();
    }
    
    setTimeout(() => {
      setLoading(false);
    }, 3000); 

}, []);

const verifyToken = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const res = await axiosAUTHAPI.post("/verify-token", { accessToken: accessToken });
      
        const resdata = res ? res.data : {}
        if(res.status === 200){
          setIsUserAuntheticated(true);
          setAuntheticatedUser(resdata?.user);
          getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications,null);
          
        } else {
          setIsUserAuntheticated(false);
          setAuntheticatedUser({});
        }
    } catch (error) {
        // Handle errors
        console.error('Error verifying token:', error);
        setIsUserAuntheticated(false);
    }
};



  return (
    <>
      {
        
          loading ? <Splash /> : isUserAuntheticated ? <Layout /> : <Login />
      }
    
    </>
  )
}

export default Auth